import { getBuilderConfigURL } from '../../../../common/utils/builder-config-url-util';
import { NoRefFields } from 'drapcode-constant';
import { processSteps } from '../collectionForm/utils';
import { getCollectionFields, getCollectionOptionsForSelect } from '../pluginComponentApi';
export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  const { projectId, collections, token, version } = opt;
  const style = document.createElement('style');
  style.innerHTML = `.checkmark::after{left: 4px;top: 4px;}checkbox{all: unset;}select option:first-child{color: grey;}select.empty{color: grey;}select option[disabled]:first-child{display: none;}input[type=webconnect-text]{display: block;}input[type=webconnect-link]{display: block;}`;
  document.head.appendChild(style);
  if (collections) {
    traitManager.addType('auto-complete-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `
      <div class="row settings--progress-bar">
        <div class="container">
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <hr/>
      <div class="settings--progress">
        <div class="gjs-container cms-data-container" style="display: none">
          <div class="gjs-row mx-auto pb-0" style="justify-content: space-between;">
            <div class="badge badge-default cms--progress--step-1">
              <i class="wb webconnect"></i>
              <span class="step--desc">Step 1: Select Collection</span>
            </div>
            <div class="cms-create-collection-container" style="display: none;flex-grow: 1;">
              <div class="gjs-row" style="flex-direction: row-reverse;">
                <a href=${getBuilderConfigURL()}collections/${version}/v/${projectId}/create?token=${token} class="direction-custom-link btn btn-outline-light py-0 px-1">
                <i class="wb webconnect-box-arrow-up-right"></i>&nbsp;Create Collection
                </a>
              </div>
            </div>
          </div>
          <div class="gjs-row">
            <div class="gjs-label-wrp">
              <div class="gjs-label select-cms-data-label" title="Collection" style="display: none">Collection</div>
            </div>
            <div id="select-cms-data-div" class="gjs-field-wrp gjs-field-wrp--select-cms-data">
              <div id="select-collection-div" class="gjs-field">
                <select class="selectCollection form-control form-control-sm options-light"></select>
              </div>
            </div>
          </div>
        </div>
        <div class="gjs-container cms-filter-container pb-0" style="display: none">
          <div class="gjs-row mx-auto pb-0">
            <div class="badge badge-default cms--progress--step-2">
              <i class="wb webconnect"></i>
              <span class="step--desc">Step 2: Select Filter</span>
            </div>
          </div>
        </div>
        <div class="gjs-container cms-field-container pb-0" style="display: none">
          <div class="gjs-row mx-auto pb-0">
            <div class="badge badge-default cms--progress--step-3">
              <i class="wb webconnect"></i>
              <span class="step--desc">Step 3: Select Field (Optional)</span>
            </div>
          </div>
        </div>
    </div>
    `;
        const cmsDataContainer = el.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = el.querySelector('.cms-create-collection-container');
        const selectCollection = el.querySelector('.selectCollection');
        selectCollection.innerHTML = '';
        let optionHtml = `<option value="">None</option>`;
        cmsCreateCollectionContainer.style.display = 'block';
        cmsDataContainer.style.display = 'block';
        optionHtml = getCollectionOptionsForSelect(collections);
        selectCollection.innerHTML = optionHtml;
        return el;
      },
      onEvent({ elInput, component }) {
        const traitName = this.model.get('name');
        const select = elInput.querySelector('.selectCollection');
        const cmsProgressBarContainer = document.querySelector('.settings--progress-bar');
        const cmsProgressStep = document.querySelector('.settings--progress');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const filterDiv = document.querySelector('.cms-filter-container');
        const fieldDiv = document.querySelector('.cms-field-container');

        let collectionName = select.value;
        console.log(
          '%c collectionName auto-complete-collection onEvent',
          'color:red',
          collectionName,
        );
        if (collectionName) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          let selectedCollectionData = collections.find(
            (coll) => collectionName === coll.collectionName,
          );
          if (selectedCollectionData) {
            const finderOptions = selectedCollectionData.finders.map((finder) => {
              return { value: finder.uuid, name: finder.name };
            });
            const filterTrait = component.getTrait('finderUuid');
            if (!filterTrait) {
              component.addTrait(
                {
                  type: 'select',
                  label: false,
                  name: 'finderUuid',
                  options: finderOptions,
                  changeProp: 1,
                },
                { at: component.getTraitIndex('collectionName') + 1 },
              );
            } else {
              filterTrait.set('options', finderOptions);
            }
            const finderUuid = component.get('finderUuid');
            if (finderUuid) {
              processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
              filterDiv.style.display = 'block';
            } else {
              filterDiv.style.display = 'none';
            }
            const fieldOptions = selectedCollectionData.fields
              .filter((field) => NoRefFields.includes(field.type))
              .map((field) => ({ value: field.fieldName, name: field.fieldTitle.en }));
            const fieldTrait = component.getTrait('fieldName');
            if (!fieldTrait) {
              component.addTrait(
                {
                  type: 'select',
                  label: false,
                  name: 'fieldName',
                  options: fieldOptions,
                  changeProp: 1,
                },
                { at: component.getTraitIndex('collectionName') + 2 },
              );
            } else {
              fieldTrait.set('options', fieldOptions);
              const fieldName = component.get('fieldName');
              if (fieldName) {
                processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
                fieldDiv.style.display = 'block';
              } else {
                fieldDiv.style.display = 'none';
              }
            }
          }
          let collectionDataStr = selectedCollectionData
            ? JSON.stringify(selectedCollectionData)
            : '';
          collectionDataStr = collectionDataStr ? collectionDataStr.replaceAll('"', '**##') : '';
          component.set('selectedCollectionData', selectedCollectionData);
          component.set('selectedCollectionStr', collectionDataStr.toString());
          component.set('collectionName', collectionName);
        } else {
          cmsDataLabel.innerHTML = '';
          const filterTrait = component.getTrait('finderUuid');
          const fieldTrait = component.getTrait('fieldName');
          component.set('collectionName', '');
          component.set('fieldName', '');
          component.set('finderUuid', '');

          if (filterTrait) {
            component.removeTrait('finderUuid');
          }

          if (fieldTrait) {
            component.removeTrait('fieldName');
          }

          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          filterDiv.style.display = 'none';
          fieldDiv.style.display = 'none';
        }
      },
      async onUpdate({ elInput, component }) {
        const cmsDataContainer = elInput.querySelector('.cms-data-container');
        const cmsCreateCollectionContainer = elInput.querySelector(
          '.cms-create-collection-container',
        );
        const selectCollectiondDiv = elInput.querySelector('#select-collection-div');
        const selectCollection = elInput.querySelector('.selectCollection');
        const cmsDataLabel = elInput.querySelector('.select-cms-data-label');

        const cmsProgressBarContainer = elInput.querySelector('.settings--progress-bar');
        const cmsProgressStep = elInput.querySelector('.settings--progress');
        const filterDiv = elInput.querySelector('.cms-filter-container');
        const fieldDiv = elInput.querySelector('.cms-field-container');

        const collectionName = component.get('collectionName');
        const fieldName = component.get('fieldName');
        const finderUuid = component.get('finderUuid');

        let selectedCollectionData = component.get('selectedCollectionData');
        console.log(
          ' %c collectionName auto-complete-collection onUpdate',
          'color:yellow',
          collectionName,
        );
        if (collectionName) {
          processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepOne');
          if (!selectedCollectionData) {
            selectedCollectionData = await getCollectionFields(collectionName, collections);
          }

          selectCollectiondDiv.style.display = 'block';
          cmsDataContainer.style.display = 'block';
          cmsCreateCollectionContainer.style.display = 'block';

          let optionHtml = `<option value="">- Select Collection -</option>`;
          optionHtml = getCollectionOptionsForSelect(collections);
          selectCollection.innerHTML = optionHtml;
          selectCollection.value = collectionName;

          const finderOptions = selectedCollectionData
            ? selectedCollectionData.finders.map((finder) => {
                return { value: finder.uuid, name: finder.name };
              })
            : [];
          const filterTrait = component.getTrait('finderUuid');

          if (filterTrait) {
            filterTrait.set('options', finderOptions);
          }

          if (finderUuid) {
            component.set('finderUuid', finderUuid);
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepTwo');
            filterDiv.style.display = 'block';
          }

          const fieldOptions = selectedCollectionData.fields
            .filter((field) => NoRefFields.includes(field.type))
            .map((field) => ({ value: field.fieldName, name: field.fieldTitle.en }));
          const fieldTrait = component.getTrait('fieldName');

          if (fieldTrait) {
            fieldTrait.set('options', fieldOptions);
          }
          if (fieldName) {
            component.set('fieldName', fieldName);
            processSteps(cmsProgressStep, true, cmsProgressBarContainer, 'stepThree');
            fieldDiv.style.display = 'block';
          }
        } else {
          processSteps(cmsProgressStep, false, cmsProgressBarContainer);
          filterDiv.style.display = 'none';
          fieldDiv.style.display = 'none';
        }
      },
    });
  } else {
    traitManager.addType('auto-complete-collection', {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
